<div class="alert alert-primary workflowPlaceholder border-primary mb-2 default-font-size" role="alert">
    <span class="lh-sm" [innerHTML]="'Settings.OrganisationBrandingSection.TabInfoInformation' | translate"></span>
</div>